module.exports = __webpack_public_path__ + "img/discount-shape.c655617b.svg";